<template>
    <page-template page-id="AcceptLegalTexts" ref="super">

        <document-title :title="$tb('pages.legalTexts.documentTitle')"></document-title>

        <template v-slot:before v-if="isTitlebarActive">
            <titlebar :text="$t('pages.legalTexts.title', {0: $store.state.appName})"></titlebar>
        </template>

        <div class="ui column">

            <h4 class="custom-ui header">{{ $t('pages.legalTexts.header') }}</h4>

            <messages id="Notifications" ref="postman"></messages>

            <template>
                <!-- TODO: Remove this once new toas checkbox structure is rolled out -->
                <legal-text-display v-if="!!requestedLegalTexts && !(requestedLegalTexts.hasOwnProperty('checkboxList') || requestedLegalTexts.hasOwnProperty('consentCategories'))" ref="toas"
                                    :requested-legal-texts="requestedLegalTexts"
                                    :show-errors="showErrors" :country="country"
                                    v-on:accepted="checkHideErrors"></legal-text-display>
                <possible-legal-texts v-if="!!requestedLegalTexts && requestedLegalTexts.hasOwnProperty('checkboxList')" ref="toas"
                                      :requested-legal-texts="requestedLegalTexts"
                                      :show-errors="showErrors" :country="country"
                                      v-on:accepted="checkHideErrors"></possible-legal-texts>
                <possible-user-consents v-if="!!requestedLegalTexts && requestedLegalTexts.hasOwnProperty('consentCategories')" ref="toas"
                                        :requested-legal-texts="requestedLegalTexts"
                                        :show-errors="showErrors"
                                        :country="country"
                                        v-on:accepted="checkHideErrors"></possible-user-consents>
            </template>

            <mandatory-label></mandatory-label>

            <div class="field">
                <button id="continue" type="submit" @click.prevent="onContinue"
                        class="ui fluid primary button" v-text="$t('common.button.continue')">
                </button>
            </div>

        </div>
    </page-template>
</template>
<script>
import PageTemplate from './template/PageTemplate.vue'
import Titlebar from '../components/Titlebar.vue'
import Messages from '../components/Messages.vue'
import MandatoryLabel from '../components/MandatoryLabel.vue'
import LegalTextDisplay from '../components/toas/LegalTextDisplay.vue'
import PossibleLegalTexts from '../components/toas/PossibleLegalTexts.vue'
import PossibleUserConsents from '../components/toas/PossibleUserConsents'
import { mixin } from '../js/ciam-mixin.js'
import { brand } from '../js/brand.js'

export default {
  components: {
    PossibleLegalTexts,
    PossibleUserConsents,
    PageTemplate,
    Titlebar,
    LegalTextDisplay,
    Messages,
    MandatoryLabel
  },
  mixins: [mixin, brand],
  props: {
    requestedLegalTexts: {
      type: Object,
      default: function () {
        return null
      }
    }
  },
  data: function () {
    return {
      uid: this.$store.state.uid,
      country: this.$store.state.country,
      showErrors: false
    }
  },
  methods: {
    onContinue: function (e) {
      this.$refs.postman.clear()
      this.showErrors = false

      if (!this.isFormValid()) return

      this.$refs.super.startLoading()

      const payload = this.$api.payloads.buildSaveLegalConsentPayload(this.$refs.toas.getAcceptedIds(), this.$store.state.country, this.getTouchpointCountry())
      this.$api.toas.saveConsent(payload, this.handleRoutingResponse, this.onToasConsentError)
    },
    isFormValid: function () {
      if (this.$refs.toas.$v.$invalid) {
        const _this = this

        this.focusFirstErrorField(function () {
          _this.showErrors = true
        })

        return false
      }

      return true
    },
    onToasConsentError () {
      console.log('Failed to save consents, continue')
      this.$refs.super.stopLoading()
    },
    checkHideErrors: function () {
      if (this.$refs.toas && this.$refs.toas.$v.$invalid) return

      this.showErrors = false
    }
  },
  mounted: function () {
    console.log(`Login legal texts [uid=${JSON.stringify(this.uid)}, legalTextDisplay=${JSON.stringify((this.requestedLegalTexts))}]`)
  },
  watch: {
    $v: {
      handler () {
        this.checkHideErrors()
      },
      deep: true
    }
  }
}
</script>

<style>
</style>
